var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-container',[_c('article-base-blockquote',{class:_vm.setPaddingClasses,attrs:{"title":_vm.value.blockquote_section_title,"description":_vm.value.blockquote_section_description}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }